import m from 'mithril';
import Component_Document_Viewer from './component_document_viewer';
import i18n from "../../shared/i18n/i18n";
import ModalManager from "../../shared/modal";
import Modal_Document_Instructions from "./modal_document_instructions";

let reloadCallback;

function openDocument(unit, course) {
    m.mount(document.getElementById('document-mount'), {
        view: function () {
            return m(Component_Document_Viewer, {
                enrolmentId: course.enrolment.id,
                unit: unit,
                callback: closeDocument
            });
        }
    });
}

function openInstructions(unit, course) {
    ModalManager.open(unit.name, ["modal-mid"], Modal_Document_Instructions, {
        unit: unit,
        callback: function () {
            openDocument(unit, course);
        }
    });
}

function closeDocument() {
    m.mount(document.getElementById('document-mount'), null);
    if (reloadCallback)
        reloadCallback();
}

const Component_Unit_Actions_Document = {
    oninit: function (vnode) {
        let unit = vnode.attrs.unit;
        let course = vnode.attrs.course;
        let unitNumber = vnode.attrs.unitNumber;
        reloadCallback = vnode.attrs.reloadCallback;
        if (unit && course && unitNumber && unit.id === unitNumber) {
            return unit?.enrolment?.allowAccess ? openInstructions(unit, course) : '';
        }
    },
    view: function (vnode) {
        let unit = vnode.attrs.unit;
        let course = vnode.attrs.course;
        reloadCallback = vnode.attrs.reloadCallback;
        return unit?.enrolment?.allowAccess ?
            m('button', {
                onclick: function () {
                    openInstructions(unit, course);
                },
                class: unit.enrolment.isCompleted ? '' : 'btn-cta'
            }, i18n.t('launch'))
            : '';
    }
};

export default Component_Unit_Actions_Document;
